document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sticky-atc]').forEach((bar) => {
    const sentinel = document.getElementById(bar.dataset.sentinelId);
    const footer = document.querySelector('footer.footer');
    const sourceButton = document.getElementById(bar.dataset.sourceButtonId);
    const stickyButton = bar.querySelector('[data-sticky-atc-button]');

    if (!sentinel || !sourceButton || !stickyButton) return;

    // True once the buy-buttons sentinel has scrolled above the viewport
    // (i.e. the customer has scrolled past it, not just that it's off-screen
    // below because the page hasn't scrolled there yet).
    let scrolledPastButtons = false;
    let footerVisible = false;

    const updateVisibility = () => {
      const shouldShow = scrolledPastButtons && !footerVisible;
      bar.classList.toggle('sticky-atc--visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            scrolledPastButtons = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          });
          updateVisibility();
        },
        { threshold: 0 }
      ).observe(sentinel);

      if (footer) {
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              footerVisible = entry.isIntersecting;
            });
            updateVisibility();
          },
          { threshold: 0 }
        ).observe(footer);
      }
    }

    stickyButton.addEventListener('click', () => {
      if (sourceButton.getAttribute('aria-disabled') === 'true' || sourceButton.disabled) return;
      sourceButton.click();
    });

    // Keep price and availability in sync if the product has variants.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event.data.variant;
        if (!variant) return;

        const priceTarget = bar.querySelector('.sticky-atc__price');
        const updatedPrice = document.querySelector(`#price-${event.data.sectionId} .price`);
        if (priceTarget && updatedPrice) {
          priceTarget.innerHTML = updatedPrice.outerHTML;
        }

        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available
          ? window.variantStrings?.addToCart || stickyButton.textContent
          : window.variantStrings?.soldOut || stickyButton.textContent;
      });
    }
  });
});
